module.exports = __webpack_public_path__ + "img/game4.b2810bab.jpg";